export const scrollTo = () => {
  const $links = document.querySelectorAll('[data-scroll]');

  $links.length &&
    $links.forEach($el => {
      $el.addEventListener('click', e => {
        e.preventDefault();
        let id = e.currentTarget.getAttribute('data-scroll');
        let elToScroll = document.getElementById(id);

        let y = elToScroll.offsetTop;

        y && handlerScroll(y);
      });
    });
};

const handlerScroll = y => {
  window.scrollTo({
    top: y - 150,
    behavior: 'smooth',
  });
};
